import { useQuery } from 'convex/react';
import { Link } from 'react-router-dom';
import { api } from '../../convex/_generated/api';
import { type Column, DataTable } from '../components/DataTable';
import { Empty } from '../components/Empty';
import { FranchiseLink } from '../components/FranchiseLink';
import { Loading } from '../components/Loading';
import { PageShell } from '../components/PageShell';

export default function HistoryIndex(): JSX.Element {
  const seasons = useQuery(api.history.seasons.listSeasons, {});

  const columns: Column<NonNullable<typeof seasons>[number]>[] = [
    {
      header: 'Year',
      cell: (s) => (
        <Link to={`/history/${s.year}`} className="hover:underline">
          {s.year}
        </Link>
      ),
    },
    {
      header: 'Champion',
      cell: (s) => <FranchiseLink franchiseId={s.championFranchiseId} name={s.championName} />,
    },
    {
      header: 'Runner-up',
      cell: (s) =>
        s.runnerUpFranchiseId && s.runnerUpName ? (
          <FranchiseLink franchiseId={s.runnerUpFranchiseId} name={s.runnerUpName} />
        ) : (
          <span className="text-gray-400">—</span>
        ),
    },
    {
      header: 'Ultimate loser',
      cell: (s) =>
        s.ultimateLoserFranchiseId && s.ultimateLoserName ? (
          <FranchiseLink franchiseId={s.ultimateLoserFranchiseId} name={s.ultimateLoserName} />
        ) : (
          <span className="text-gray-400">—</span>
        ),
    },
  ];

  return (
    <PageShell title="BDL History" subtitle="Champions, records, and dynasty data 2009–present.">
      {seasons === undefined ? (
        <Loading />
      ) : seasons.length === 0 ? (
        <Empty>No seasons recorded yet.</Empty>
      ) : (
        <>
          <h2 className="font-semibold mb-2">Champions</h2>
          <DataTable columns={columns} rows={seasons} rowKey={(s) => s.year} />
          <h2 className="font-semibold mt-8 mb-2">Browse</h2>
          <div className="grid md:grid-cols-2 gap-3">
            <div
              className="border rounded p-3 bg-white text-gray-400 cursor-not-allowed"
              aria-disabled
            >
              Records (Phase 3)
            </div>
            <div
              className="border rounded p-3 bg-white text-gray-400 cursor-not-allowed"
              aria-disabled
            >
              Head-to-head (Phase 3)
            </div>
            <div
              className="border rounded p-3 bg-white text-gray-400 cursor-not-allowed"
              aria-disabled
            >
              Draft history (Phase 3)
            </div>
            <div className="border rounded p-3 bg-white">
              <div className="font-semibold mb-1">Franchise pages</div>
              <div className="text-sm text-gray-600">
                Click any franchise name in the table above (or in any season's standings) to open
                its career page.
              </div>
            </div>
          </div>
        </>
      )}
    </PageShell>
  );
}
